<template>
  <div>
		<Loading :active.sync="isLoading" :can-cancel="true" :is-full-page="true" />
    <section
      id="home"
      class="video-hero"
      data-section="home"
    >
      <div class="overlay top-bk"></div>
      <!-- <a 
				ref="player"
				class="player" 
				data-property="{videoURL:'https://www.youtube.com/watch?v=vqqt5p0q-eU',containment:'#home', showControls:false, autoPlay:true, loop:true, mute:true, startAt:0, opacity:1, quality:'default'}"
      ></a>-->
    </section>
    <div class="colorlib-work-featured colorlib-bg-white">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-md-offset-2 text-center colorlib-heading animate-box">
            <h1>{{ $tc('contact.label', 1) }} <i class="icon-paperplane mr-2"></i></h1>
            <p>{{ $tc('contact.any_questions', 1) }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-7 animate-box">
            <h2>{{ $tc('message.label', 1) }}</h2>
            <form v-on:submit.prevent="sendMessage">
              <div class="row form-group">
                <div class="col-md-6">
                  <!-- <label for="fname">First Name</label> -->
                  <input 
										v-model="message.name" 
										type="text" 
										id="fname" 
										class="form-control" 
										:placeholder="$tc('name', 1)" 
										required
									/>
                </div>
                <div class="col-md-6">
                  <!-- <label for="lname">Last Name</label> -->
                  <input 
										v-model="message.company_name" 
										type="text" 
										id="lname" 
										class="form-control" 
										:placeholder="$tc('company', 1)"
									/>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-md-12">
                  <!-- <label for="email">Email</label> -->
                  <input
										v-model="message.email"
                    type="text"
                    id="email"
                    class="form-control"
                    :placeholder="$tc('email', 1)"
										required
                  />
                </div>
              </div>

              <div class="row form-group">
                <div class="col-md-12">
                  <!-- <label for="subject">Subject</label> -->
                  <input
										v-model="message.subject"
                    type="text"
                    id="subject"
                    class="form-control"
                    :placeholder="$tc('subject', 1)"
										required
                  />
                </div>
              </div>

              <div class="row form-group">
                <div class="col-md-12">
                  <!-- <label for="message">Message</label> -->
                  <textarea
										v-model="message.text"
                    name="message"
                    id="message"
                    cols="30"
                    rows="10"
                    class="form-control"
                    :placeholder="$tc('your_message', 1)"
                  ></textarea>
                </div>
              </div>
              <div class="form-group text-right">
                <button 
                  type="submit" 
                  class="btn btn-primary"
                >
                  {{ $tc('action.send', 1) }}
                  <i class="icon-paperplane mr-2"></i>
                </button>
              </div>
            </form>
          </div>
          <div class="col-md-4 offset-md-1 animate-box">
            <h2>{{ $tc('contact.suporte_contact', 1) }}</h2>
            <div class="row">
              <div class="col-md-12">
                <div class="contact-info-wrap-flex">
                  <!-- <div class="con-info">
                    <p>
                      <span>
                        <i class="icon-location-2"></i>
                      </span> 198 West 21th Street,
                      <br />Suite 721 New York NY 10016
                    </p>
                  </div> -->
                  <!-- <div class="con-info">
                    <p>
                      <span>
                        <i class="icon-phone3"></i>
                      </span>
                      <a href="tel://1234567920">+ 1235 2355 98</a>
                    </p>
                  </div> -->

									<div 
										class="media-body"
									> 
										<p>
											{{ $tc('contact.if_prefer_send_email', 1) }}
										</p>
									</div>


                  <div class="con-info">
										<span>
											<i class="icon-umbrella mr-2"></i>
										</span>

										<a href="mailto:support@processflex.com">
											support@processflex.com
										</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
	name: "ContactPage",
	components: {
		Loading
	},
  data() {
    return {
      message: {
        name: "",
        company_name: "",
        subject: "",
        email: "",
        text: ""
      },
      isLoading: false,
      showConfirmMessage: false
    };
  },
  mounted() {
    this.$helpers.ga.openPage({ page: 'contact', title: 'Contact' });
		this.$helpers.scrollTop(0);
  },
  methods: {
		clearForm() {
			this.message = {
        name: "",
        company_name: "",
        subject: "",
        email: "",
        text: ""
      }
		},
    sendMessage() {
      this.isLoading = true;

      this.$helpers.ga.event({
        event: "submit_form",
        label: "send_message",
      });
			
      window.$axios
        .post("api/site/message", { data: this.message })
					.then(response => {
						console.log('Sent msn')
						this.posts = response.data;
						this.showConfirmMessage = true;
						this.clearForm();
						this.$swal({
							icon: 'success',
							title: 'Mensagem envida',
							text: 'Responderemos em breve.'
						});
					})
					.catch(error => {
						console.log(error);
					})
					.finally( () => {
						this.isLoading = false;
					});
    }
  }
};
</script>